import {getAuth} from 'firebase/auth'
import {firebaseApp} from './firebaseConfig'

export const firebaseAuth = getAuth(firebaseApp)

/**  Firebase Authentication エラーコード */
export type FirebaseAuthErrCode =  'auth/email-already-in-use' | 'auth/wrong-password' | 'auth/user-not-found' | 'auth/user-disabled' | 'auth/invalid-email'
